class DynamicTranslationService {
    constructor() {
        this.industriesTranslation = {};
        this.getIndustryTranslation = this.getIndustryTranslation.bind(this);
        this.addIndustriesTranslations = this.addIndustriesTranslations.bind(this);
    }

    addIndustriesTranslations(translationMap = {}) {
        this.industriesTranslation = {
            ...this.industriesTranslation,
            ...translationMap,
        };
    }

    getIndustryTranslation(key) {
        return this.industriesTranslation[key] || key;
    }
}

const dynamicTranslationService = new DynamicTranslationService();

export default dynamicTranslationService;
